import Layout from '~/layouts/default';
import Seo from '~/components/seo';
import Section from '~/components/tos/section';
import { getDocsUrl } from '~/helpers/url';

export default function Page() {
  return (
    <>
      <Layout>
        <Seo
          title="Terms of Service"
          description="Terms and Conditions of Repman"
          path="/terms-of-service"
        />
        <section className="tos">
          <div className="container">
            <article className="article">
              <Section title="Terms of service" primary>
                Terms and Conditions of <b>BDY Sp. z o.o. Sp. k.</b>, a company
                incorporated and registered in Poland whose registered office is
                at Migdałowa 4, 02-796, Warszawa, referenced in this document as
                &quot;Repman&quot;. Please read carefully this agreement before
                using the repman.io web site or any other services of Repman
                (&quot;Service&quot;). By clicking the confirmation button on
                the sign-up form you (&quot;Customer&quot;) agree to become
                bound by the Terms and Conditions (&quot;Terms of Service&quot;)
                of this agreement, to the exclusion of all other terms. Repman
                reserves the right to update and change the Terms of Service at
                any time without notice.
              </Section>
              <Section title="Account terms">
                <li>You must be 13 years old or more to use the Service.</li>
                <li>
                  You must provide your correct data: a valid email address, and
                  any other information required for the signup process.
                </li>
                <li>
                  You are responsible for keeping the privacy and safety of your
                  account. Repman cannot be and would not be responsible for the
                  damages or losses ensuing as the result of your failure to
                  protect your login information, including your password.
                </li>
                <li>
                  You must be human. Accounts registered by automatic machines
                  are forbidden.
                </li>
                <li>
                  Your login can be used only by one person. A co-login between
                  two or more persons is forbidden.
                </li>
                <li>
                  You cannot use the Service for purposes forbidden by law. By
                  using the Service you cannot break any law and jurisdiction,
                  especially emphasizing copyright law.
                </li>
              </Section>
              <Section title="Cancellation and Termination">
                <li>
                  You can{' '}
                  <b><a href={getDocsUrl('user-profile')}>cancel your account</a></b>{' '}
                  at any time by going into your Profile in the navigation bar
                  at the top of the screen.
                </li>
                <li>
                  Your account and all its content would immediately be removed
                  after the cancellation of the account. We will retain and use
                  your information as necessary to comply with our legal
                  obligations, resolve disputes, and enforce our agreements, but
                  barring legal requirements, we will delete your full profile
                  and the Content of your repositories within 30 days of
                  cancellation or termination (though some information may
                  remain in encrypted backups). This information can not be
                  recovered once your account is canceled.
                </li>
                <li>
                  Upon request, we will make a reasonable effort to provide an
                  account owner with a copy of your lawful, non-infringing
                  account contents after account cancellation, termination, or
                  downgrade. You must make this request within 30 days of
                  cancellation, termination, or downgrade.
                </li>
                <li>You can cancel the account any time.</li>
                <li>
                  Repman reserves the rights to cancellation of the account,
                  suspension, change or remove it without notice.
                </li>
              </Section>
              <Section title="Copyright and Content Ownership">
                <li>
                  Repman considers the contents of repositories hosted on the
                  Service to be confidential to you.
                </li>
                <li>
                  Repman will protect the contents of repositories hosted on the
                  Service, as well as server authentication data, integrations
                  details, and encrypted environment variables, from
                  unauthorized use, access, or disclosure in the same manner
                  that we would use to protect our own confidential information
                  of a similar nature and in no event with less than a
                  reasonable degree of care.
                </li>
                <li>
                  Repman does not claim any rights to intellectual property
                  uploaded by you to the Service.
                  <br />
                  Repman reserves the right to discard and delete content in the
                  Service.
                </li>
                <li>
                  Repman does not allow third parties to access the contents of
                  your projects and files included. Repman stores and processes
                  them to make the Service functional: however, all these
                  processes are automated.
                </li>
                <li>
                  Repman employees may only access the content of repositories
                  hosted on the Service in the following situations: <br />
                  1. With your consent and knowledge, for support reasons. If
                  Repman accesses a repository for support reasons, we will only
                  do so with the owner&apos;s consent and knowledge.
                  <br />
                  2. When access is required for security reasons.
                </li>
                <li>
                  Repman reserves the right to any and all protected components
                  of its Service, including but not limited to: name of service,
                  design, artwork and individual features. You cannot copy,
                  modify, adapt, distribute, reverse engineer and decompile any
                  part of the Service which is in the possession of Repman or
                  persons who created them.
                </li>
                <li>
                  You shall not sell, license, rent, or otherwise use or exploit
                  any content for commercial use or in any way that violates any
                  third-party right.
                </li>
              </Section>
              <Section title="General Regulations and Rules of Conduct">
                <li>
                  You use the delivered Service &quot;as-is&quot; and &quot;as
                  available&quot; at your own risk.
                </li>
                <li>
                  You are aware that your data and its processing can be
                  transferred in a not cryptic transmission by any kind of web
                  and net devices.
                </li>
                <li>
                  You agree that you will not transmit, distribute, post, store,
                  link, or otherwise traffic in content, information, software,
                  or materials on or through the Service that (a.) is unlawful,
                  threatening, abusive, harassing, defamatory, libelous,
                  deceptive, fraudulent, invasive of another&apos;s privacy,
                  tortious, offensive, profane, contains or depicts pornography
                  that is unlawful, or is otherwise inappropriate as determined
                  by us in our sole discretion, (b.) you know is false,
                  misleading, untruthful or inaccurate, (c.) constitutes
                  unauthorized or unsolicited advertising, (d.) impersonates any
                  person or entity, including any of our employees or
                  representatives, or (e.) includes anyone&apos;s identification
                  documents or sensitive financial information
                </li>
                <li>
                  You shall not (a.) take any action that imposes or may impose
                  (as determined by us in our sole discretion) an unreasonable
                  or disproportionately large load on our (or our third-party
                  providers&apos;) infrastructure; (b.) interfere or attempt to
                  interfere with the proper working of the Services or any
                  activities conducted on the Services; (c.) bypass, circumvent
                  or attempt to bypass or circumvent any measures we may use to
                  prevent or restrict access to the Services (or other accounts,
                  computer systems or networks connected to the Services); (d.)
                  run any form of auto-responder or &quot;spam&quot; on the
                  Services; (e.) use manual or automated software, devices, or
                  other processes to &quot;crawl&quot; or &quot;spider&quot; any
                  page of the Website; (f.) harvest or scrape any Content from
                  the Services; (g.) use the Services for high risk activities
                  including but not limited to the operation of nuclear
                  facilities, air traffic control, life support systems, or any
                  other use where the failure of service could lead to death,
                  personal injury, or environmental damage; or (h.) otherwise
                  take any action in violation of our guidelines and policies.
                </li>
                <li>
                  It is strictly forbidden to use the service to mine Bitcoin
                  and other cryptocurrencies. Such activity will result in
                  immediate suspension of the account and legal action against
                  the workspace owner.
                </li>
                <li>
                  You shall not (directly or indirectly): (a.) decipher,
                  decompile, disassemble, reverse engineer or otherwise attempt
                  to derive any source code or underlying ideas or algorithms of
                  any part of the Services (including without limitation any
                  application), except to the limited extent applicable laws
                  specifically prohibit such restriction, (b.) modify,
                  translate, or otherwise create derivative works of any part of
                  the Services, or (c.) copy, rent, lease, distribute, or
                  otherwise transfer any of the rights that you receive
                  hereunder. You shall abide by all applicable local, state,
                  national and international laws and regulations.
                  <br />
                  Repman does not guarantee that the Service will meet your
                  individual requirements, act continuously, there will be no
                  errors, be safe or timely, the outcome of the service will be
                  precise and reliable and that all errors will be repaired. The
                  same applies to all products, services and materials bought or
                  acquired by the Service.
                </li>
                <li>
                  Some parts of Repman functionality may not work with your
                  hardware/software or other third-party services (ex: hosting
                  providers).
                </li>
                <li>
                  You understand and accept that Repman is not liable for any
                  direct, indirect, casual, special, consequential or exemplary
                  damages, including but not limited to damages or loss of
                  profits, goodwill, data or other intangible losses - even when
                  Repman has been warned about the possibility of such damages.
                </li>
                <li>
                  The Terms of Service constitute the conditions of the contract
                  between Repman and you and define the rules of using the
                  Service.
                </li>
                <li>
                  If any provision of the Terms of Service is held invalid or
                  otherwise unenforceable, the enforceability of the remaining
                  provisions shall not be impaired thereby.
                </li>
                <li>
                  All questions concerning the Terms of Service should be
                  addressed to{' '}
                  <b>
                    <a href="mailto:support@buddy.works">support@buddy.works</a>
                  </b>
                  .
                </li>
              </Section>
            </article>
          </div>
        </section>
      </Layout>
    </>
  );
}
